import {planTypes} from "@/common/constants";
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  key: planTypes[planTypes.VIDEO_MANAGEMENT],
  data () {
    return {
      logo: getPlanLogo(planTypes.VIDEO_MANAGEMENT),
      title: this.$t('billing.video_management.title'),
      planType: planTypes.VIDEO_MANAGEMENT,
      trackingPlanName: 'zoom video management',
    }
  }
};
